import React from "react";
import type { FilterProps } from "../../../../viewmodels/qaReports/qaReportTypes";
import ProductPluSearch from "../ProductPluSearch";
// @ts-expect-error The legacy input has no TypeScript declarations.
import Input from "../../../controls/Input";

export default function ProductionDetailsFilter(props: FilterProps) {
  const { filters, setFilters, logout, disabled } = props;
  return (
    <div className="grid grid-cols-6 gap-3">
      <ProductPluSearch
        value={filters.product}
        onChange={(product) => setFilters({ ...filters, product })}
        logout={logout}
        disabled={disabled}
      />
      <div className="col-span-6 sm:col-span-3 lg:col-span-2">
        <Input
          label="Lot number"
          name="lotNumber"
          value={filters.lotNumber}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFilters({ ...filters, lotNumber: e.target.value })}
          labelOn={true}
          type="text"
          className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
        />
      </div>
    </div>
  );
}
